module.exports = __webpack_public_path__ + "static/parisjug-504755bacb0f07924777e61ce84f6a6c.png";